import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SIcon, SInput } from '@strana-artw/ui-kit';
import { maxLength, minLength, required, sameAs } from '@vuelidate/validators';
import { computed } from 'vue';
import { VALIDATION_INJECTION_KEY } from '@/shared/composables';
import { asciiChars, spaceCheck } from '@/shared/lib/utils/patterns';
import { resolveFieldError } from './resolveFieldError';
export default {
  name: 'FormFieldPassword',
  components: {
    SInput: SInput,
    SIcon: SIcon
  },
  inject: {
    validation: VALIDATION_INJECTION_KEY
  },
  props: {
    field: {
      type: String,
      default: 'password'
    },
    label: {
      type: String,
      default: 'Пароль'
    },
    showPass: {
      type: Boolean,
      default: false
    },
    sameAs: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    },
    editing: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    errors: function errors() {
      return resolveFieldError(this.validation.$v[this.field], {
        asciiChars: 'Пароль должен содержать только латинские буквы, цифры и символы',
        spaceCheck: 'Пароль не должен содержать пробелы',
        required: 'Введите пароль',
        minLength: 'Слишком короткий пароль',
        maxLength: 'Слишком длинный пароль',
        sameAsPassword: 'Пароли должны совпадать',
        serverError: this.validation.serverErrors[this.field] || 'Ошибка на сервере'
      });
    },
    appendIcon: function appendIcon() {
      if (this.disabled) {
        return undefined;
      }
      if (this.editing) {
        return 'edit';
      }
      return this.showPass ? 'eye-off' : 'eye';
    }
  },
  created: function created() {
    var field = this.field,
      validation = this.validation;
    var sameAsField = this.sameAs;
    this.$set(this.validation.validators.form, field, _objectSpread({
      asciiChars: asciiChars,
      required: required,
      minLength: minLength(8),
      maxLength: maxLength(35),
      spaceCheck: spaceCheck,
      serverError: function serverError() {
        return !validation.serverErrors[field];
      }
    }, Boolean(sameAsField) && {
      sameAsPassword: sameAs(computed(function () {
        return validation.form[sameAsField];
      }), sameAsField)
    }));
    this.$set(this.validation.form, field, '');
  },
  beforeDestroy: function beforeDestroy() {
    this.$delete(this.validation.form, this.field);
    this.$delete(this.validation.validators.form, this.field);
  },
  methods: {
    clearServerError: function clearServerError() {
      if (this.validation.serverErrors[this.field]) {
        this.$delete(this.validation.serverErrors, this.field);
      }
    },
    onEnter: function onEnter() {
      this.$emit('enterClick');
    }
  }
};